import { LogMessageDataType } from '@/common/logs/LogMessageDataType';
import { getPreferences } from '@/client/utils/PreferencesManager';
import { Log } from '@/common/logs/Log';
import { tileTypeToString } from '@/common/TileType';
const context = {
    playerView: undefined,
    players: new Map(),
};
export function setTranslationContext(playerView) {
    context.playerView = playerView;
    context.players.clear();
    for (const player of playerView.players) {
        context.players.set(player.color, player.name);
    }
    // MarsBot is not in the player list, so without this its color would show instead of its name.
    const marsBot = playerView.game?.marsBot;
    if (marsBot !== undefined) {
        context.players.set(marsBot.color, marsBot.name);
    }
}
export function translateMessage(message) {
    message.message = translateText(message.message);
    return Log.applyData(message, (datum) => {
        if (datum === undefined) {
            return '';
        }
        switch (datum.type) {
            case LogMessageDataType.PLAYER:
                return context.players.get(datum.value) ?? datum.value;
            case LogMessageDataType.TILE_TYPE:
                return tileTypeToString[datum.value];
            case LogMessageDataType.MARKDOWN:
                return datum.value;
            default:
                return translateText(String(datum.value));
        }
    });
}
let translated;
export function setTranslationsForTest(translations) {
    window._translations = translations;
    translated = undefined;
}
export function translateText(englishText) {
    const lang = getPreferences().lang;
    const translations = window._translations;
    if (lang === 'en' || translations === undefined) {
        return englishText;
    }
    englishText = normalizeText(englishText);
    // Don't translate non-word strings
    if (/^(\W|\d)*$/.test(englishText)) {
        return englishText;
    }
    // Don't translate strings that are non-word apart from icon shortcodes such as :r:megacredits:
    // Those should be sent as MARKDOWN data, which isn't translated.
    // TODO: Remove on 2027-01-01.
    if (/^(\W|\d)*$/.test(englishText.replace(/:[a-z]+:[\w-]+:/g, ''))) {
        return englishText;
    }
    let translatedText = translations[englishText];
    // Check if translated word is in brackets
    if (translatedText === undefined) {
        const isTextInBrackets = englishText.startsWith('(') && englishText.endsWith(')');
        if (isTextInBrackets) {
            const translationAttempt = translations[englishText.slice(1, -1)];
            if (translationAttempt) {
                translatedText = `(${translationAttempt})`;
            }
        }
    }
    if (translatedText === undefined) {
        // The i18n plugin sends translated strings back here. That means that sometimes this tries to
        // Since the phrase it sends is not English, it can't be found, and this reports an error to the
        // browser.
        //
        // This Set reduces that by seeing if the string is of the new language, and ignores reporting the error.
        if (translated === undefined) {
            translated = new Set();
            for (const k in translations) {
                if (Object.hasOwn(translations, k)) {
                    translated.add(translations[k]);
                }
            }
        }
        if (!translated.has(englishText)) {
            console.log(`${lang} - please translate: "${englishText}"`);
        }
    }
    return translatedText || englishText;
}
export function translateTextWithParams(englishText, params) {
    const data = params.map((p) => {
        return {
            type: LogMessageDataType.RAW_STRING,
            value: p,
        };
    });
    const message = {
        message: englishText,
        data: data,
    };
    return translateMessage(message);
}
// Remove newlines and compress multiple spaces.
function normalizeText(text) {
    return text.replace(/[\n\r]/g, '').replace(/[ ]+/g, ' ').trim();
}
function translateChildren(node, params) {
    for (let i = 0, length = node.childNodes.length; i < length; i++) {
        const child = node.childNodes[i];
        if (child.nodeType === Node.TEXT_NODE) {
            const text = child;
            const translatedText = params ? translateTextWithParams(text.data, params) : translateText(text.data);
            if (translatedText !== text.data) {
                text.data = translatedText;
            }
        }
        else {
            if (child.nodeType === Node.ELEMENT_NODE && child.getAttribute('tm-has-i18n') === 'true') {
                continue;
            }
            translateChildren(child, params);
        }
    }
}
export function translateTextNode(el, binding) {
    let params = undefined;
    if (binding?.value) {
        params = binding.value instanceof Array ? binding.value : [binding.value];
    }
    translateChildren(el, params);
}
export const $t = function (msg) {
    if (!msg) {
        return '';
    }
    if (typeof msg === 'number') {
        return msg.toString();
    }
    if (typeof msg === 'string') {
        return translateText(msg);
    }
    return translateMessage(msg);
};
